import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { MedicalDocumentItem, MedicalDocumentItemDto } from "@/Documents/Models/Medical/MedicalDocumentItem";

class MedicalDocumentTableItem implements ITableDataSourceItem<MedicalDocumentItem> {
    public Model: MedicalDocumentItem;
    public IsSelected: boolean;
    public IsInFocus: boolean;
    public Name: string;

    constructor(model: MedicalDocumentItem) {
        this.Model = model;
        this.IsSelected = false;
        this.IsInFocus = false;
    }

    public static FromMedicalDocumentItemResponse(modelResponse: MedicalDocumentItemDto): MedicalDocumentTableItem {
        let medicalDocumentItem = new MedicalDocumentItem(modelResponse);
        return new MedicalDocumentTableItem(medicalDocumentItem);
    }
}

export { MedicalDocumentTableItem };
